import NewPostForm from '../../components/Posts/NewPostForm/NewPostForm';

export default function NewPostPage() {
  return (
    <section className='section--new--post'>
      <NewPostForm />
    </section>
  );
}
